import { PackStatus } from 'app/typings/core/admin/packs/enum/pack';

import type { GroupedHotelPackages, HotelPackage } from '../../_types';

export const getPackageNameForHotel = (pkg: HotelPackage) =>
  pkg.nameForHotel?.trim() !== ''
    ? pkg.nameForHotel?.trim()
    : `Package #${pkg.id}`;

export const getPackageNameForUser = (pkg: HotelPackage) =>
  pkg.nameForUser?.trim() !== '' && pkg.nameForUser !== undefined
    ? pkg.nameForUser?.trim()
    : null;

export const getPackageStatus = (pkg: HotelPackage): PackStatus => {
  if (pkg.status === PackStatus.PUBLISHED) {
    return PackStatus.PUBLISHED;
  }

  return PackStatus.UNPUBLISHED;
};

export const getPackageStatusLabel = (status: PackStatus) => {
  switch (status) {
    case PackStatus.PUBLISHED:
      return 'Published';
    case PackStatus.HIDDEN:
      return 'Hidden';
    case PackStatus.UNPUBLISHED:
    default:
      return 'Unpublished';
  }
};

export const isDaytimePackage = (pkg: HotelPackage) => pkg.isDaytime ?? false;

export const groupPackagesByPeriod = (
  packages: HotelPackage[]
): GroupedHotelPackages => ({
  nightStayPackages: packages.filter((pkg) => !isDaytimePackage(pkg)),
  daytimePackages: packages.filter(isDaytimePackage),
});

export const getPackagePath = (pkg: HotelPackage, isHotelLegacy: boolean) =>
  isHotelLegacy ? `/packs/legacy/${pkg.id}` : `/packs/${pkg.id}`;
